import { Box, Stack, Typography } from '@mui/material';
import { useCallback } from 'react';
import { FileRejection, useDropzone } from 'react-dropzone';

import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { translate } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';

export function DropOrSelectCsvFile({
  onCsvFileSelected: onFileSelected,
}: {
  onCsvFileSelected: (file: File) => void;
}) {
  const onDrop = useCallback(
    (acceptedFiles: File[], fileRejections: FileRejection[]) => {
      if (fileRejections.length > 0) {
        console.log('fileRejections:', fileRejections);
        return;
      }
      const file = acceptedFiles[0];
      onFileSelected(file);
    },
    [onFileSelected],
  );

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    accept: { 'text/csv': ['.csv'] },
    noClick: true,
    noKeyboard: true,
    multiple: false,
    maxFiles: 1,
    onDrop,
  });

  return (
    <Stack
      {...getRootProps()}
      sx={{
        p: 4,
        border: '1px dashed',
        borderRadius: '0.5rem',
        borderColor: isDragActive
          ? ColorsRaw.main.Navy_Light
          : ColorsRaw.anthracite.Anthracite_5,
        backgroundColor: isDragActive
          ? ColorsRaw.anthracite.Anthracite_4
          : 'transparent',
        alignItems: 'center',
      }}
    >
      <input {...getInputProps()} />
      <Stack sx={{ alignItems: 'center', gap: 2 }}>
        <Box>
          <TableIcon />
        </Box>
        <Typography sx={{ fontSize: '1.5rem', fontWeight: 800 }}>
          {translate('ProjectsTour.OnTour.ModalImportCsv.drop-a-csv-file')}
        </Typography>
        <Typography sx={{ fontSize: '1rem' }}>
          {translate('ProjectsTour.OnTour.ModalImportCsv.or')}
        </Typography>
        <FSPrimaryButton onClick={open} sx={{ mt: 1 }}>
          {translate('ProjectsTour.OnTour.ModalImportCsv.select-a-csv-file')}
        </FSPrimaryButton>
      </Stack>
    </Stack>
  );
}

function TableIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M6 42V6H42V42H6ZM10 18H38V10H10V18ZM20.65 28H27.35V22H20.65V28ZM20.65 38H27.35V32H20.65V38ZM10 28H16.65V22H10V28ZM31.35 28H38V22H31.35V28ZM10 38H16.65V32H10V38ZM31.35 38H38V32H31.35V38Z"
        fill="white"
      />
    </svg>
  );
}
